var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobeX = function SvgGlobeX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#50818ade-018f-4bfb-bc7c-93554e203bdfa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BB0007",
    fillOpacity: 0.836,
    d: "M8 .667a7.333 7.333 0 0 1 7.302 8H6.038a9.54 9.54 0 0 0 1.758 4.693l.204.273v1.7A7.333 7.333 0 1 1 8 .667m6.195 10.195a.666.666 0 1 1 .943.943L13.942 13l1.196 1.195a.666.666 0 1 1-.943.943L13 13.942l-1.195 1.196a.666.666 0 1 1-.943-.943L12.058 13l-1.196-1.195a.666.666 0 1 1 .943-.943L13 12.058zM2.036 8.667a6.01 6.01 0 0 0 4.447 5.14A10.9 10.9 0 0 1 4.7 8.667zm4.447-6.474a6.01 6.01 0 0 0-4.447 5.14H4.7c.15-1.842.766-3.61 1.783-5.14M8 2.367a9.53 9.53 0 0 0-1.962 4.966h3.924A9.53 9.53 0 0 0 8 2.367m1.517-.174a10.9 10.9 0 0 1 1.783 5.14h2.664a6.01 6.01 0 0 0-4.447-5.14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "50818ade-018f-4bfb-bc7c-93554e203bdfa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgGlobeX;